module.exports = __webpack_public_path__ + "static/media/2022__K8A0155.b88a5bf4.jpg";